import { Component, OnInit, NgZone, Input } from '@angular/core';

declare const annyang: any;
@Component({
    selector: 'voice-recognition',
    templateUrl: './voice-recognition.component.html',
    styleUrls: ['./voice-recognition.component.scss'],
    standalone: false
})
export class VoiceRecognitionComponent implements OnInit {
  @Input() commands: any;
  voiceActiveSectionDisabled: boolean = true;
  voiceActiveSectionError: boolean = false;
  voiceActiveSectionSuccess: boolean = false;
  voiceActiveSectionListening: boolean = false;
  voiceText: any;

  constructor(private ngZone: NgZone) {}
  ngOnInit(): void {
    annyang.setLanguage('fr-FR');
    console.log('this.commands', this.commands);

    if (this.commands && annyang) annyang.addCommands(this.commands);
  }

  initializeVoiceRecognitionCallback(): void {
    annyang.addCallback('error', err => {
      if (err.error === 'network') {
        this.voiceText = 'Internet is require';
        annyang.abort();
        this.ngZone.run(() => (this.voiceActiveSectionSuccess = true));
      } else if (this.voiceText === undefined) {
        this.ngZone.run(() => (this.voiceActiveSectionError = true));
        annyang.abort();
      }
    });

    annyang.addCallback('soundstart', res => {
      this.ngZone.run(() => (this.voiceActiveSectionListening = true));
    });

    annyang.addCallback('end', () => {
      if (this.voiceText === undefined) {
        this.ngZone.run(() => (this.voiceActiveSectionError = true));
        annyang.abort();
      }
    });

    // annyang.addCallback("result", (userSaid) => {
    //   this.ngZone.run(() => (this.voiceActiveSectionError = false));

    //   let queryText: any = userSaid[0];

    //   annyang.abort();

    //   this.voiceText = queryText;

    //   this.ngZone.run(() => (this.voiceActiveSectionListening = false));
    //   this.ngZone.run(() => (this.voiceActiveSectionSuccess = true));
    // });
  }

  startVoiceRecognition(): void {
    this.voiceActiveSectionDisabled = false;
    this.voiceActiveSectionError = false;
    this.voiceActiveSectionSuccess = false;
    this.voiceText = undefined;

    if (annyang) {
      let commands = {
        démo: () => {
          console.log('test');
        },
      };
      if (this.commands) annyang.addCommands(this.commands);
      else annyang.addCommands(commands);

      this.initializeVoiceRecognitionCallback();

      annyang.start();
    }
  }

  closeVoiceRecognition(): void {
    this.voiceActiveSectionDisabled = true;
    this.voiceActiveSectionError = false;
    this.voiceActiveSectionSuccess = false;
    this.voiceActiveSectionListening = false;
    this.voiceText = undefined;

    if (annyang) {
      annyang.abort();
    }
  }
}
